@if(this.isContactAvailable){
    <div class="page_title_content">
        <div class="page_title">{{'CONTACTS.TITLE' | translate}}</div>    
    </div>

    <div id="contacts_content">

        @if(this.communications?.call?.isEnabled 
            && this.communications?.call?.recipient 
            && this.communications?.call?.recipient !== ''){
            <demooz-card   
                class="card_contact"
                [withMargin]="false"
                (click)="this.contactByPhone()"
                >        
                <div class="contact">
                    <ion-icon name="call"></ion-icon>            
                    <div class="contact_infos">
                        <div class="contact_name">{{this.communications.call.firstName}} {{this.communications.call.lastName}}</div>
                        @if(this.communications.call.jobTitle && this.communications.call.jobTitle !== ''){
                            <div class="contact_job">{{this.communications.call.jobTitle}}</div>
                        }
                    </div>     
                </div>
            </demooz-card>
        }

        @if(this.communications?.sms?.isEnabled 
            && this.communications?.sms?.recipient 
            && this.communications?.sms?.recipient !== ''){
            <demooz-card   
                class="card_contact"
                [withMargin]="false"
                (click)="this.contactBySms()"
                >      
                <div class="contact">
                    <ion-icon name="chatbubble"></ion-icon>       
                    <div class="contact_infos">
                        <div class="contact_name">{{this.communications.sms.firstName}} {{this.communications.sms.lastName}}</div>
                        @if(this.communications.sms.jobTitle && this.communications.sms.jobTitle !== ''){
                            <div class="contact_job">{{this.communications.sms.jobTitle}}</div>
                        }
                    </div>  
                </div>
            </demooz-card>
        }

        @if(this.communications?.email?.isEnabled 
            && this.communications?.email?.recipient 
            && this.communications?.email?.recipient !== ''){
            <demooz-card   
                class="card_contact"
                [withMargin]="false"
                (click)="this.contactByMail()"
                >     
                <div class="contact">
                    <ion-icon name="mail"></ion-icon>          
                    <div class="contact_infos">
                        <div class="contact_name">{{this.communications.email.firstName}} {{this.communications.email.lastName}}</div>
                        @if(this.communications.email.jobTitle && this.communications.email.jobTitle !== ''){
                            <div class="contact_job">{{this.communications.email.jobTitle}}</div>
                        }
                    </div>   
                </div>
            </demooz-card>
        }

    </div>
}